import { memo } from "react";
import { styled } from "styled-components";

import { UIChip } from "common/components";
import { ListItemWrapper } from "common/components/lists/ListItemWrapper";
import { ListImage, ListLink } from "common/components/lists/ListLink";
import { breakWordStyle, lineTruncationStyle } from "common/styles";
import type { Stakeholder } from "entities/stakeholders/types";

const StyledListLink = styled(ListLink)`
  display: flex;
  align-items: center;
`;

const StyledTitle = styled.div`
  font-weight: bold;
  font-size: 1rem;
  margin: 0 0 0.5rem;

  ${breakWordStyle}
  ${lineTruncationStyle(1)}
`;

const StyledType = styled(UIChip)`
  font-size: 0.9rem;
  margin: 0;
  margin-right: 10px;

  &:last-child {
    margin-right: 0;
  }
`;

const StyledImage = styled(ListImage)`
  border-radius: 4px;
  margin-right: 1rem;
  height: 75px;
  width: 60px;
  min-width: 60px;
`;

type StakeholderListItemProps = { isSelected?: boolean; link: string; onClick?: () => void; stakeholder: Stakeholder };

export const StakeholderListItem = memo(
  ({ isSelected = false, link, onClick, stakeholder }: StakeholderListItemProps) => (
    <ListItemWrapper trackPage="Discover" isLocked={false} isSelected={isSelected}>
      <StyledListLink to={link} onClick={onClick}>
        <StyledImage src={stakeholder.images?.thumbnail} />
        <div>
          <StyledTitle>{stakeholder.full_name}</StyledTitle>
          <StyledTitle>{stakeholder.primary_organisation}</StyledTitle>
          {stakeholder.roles?.map((role) => (
            <StyledType key={role.id} disabled>
              {role.name}
            </StyledType>
          ))}
        </div>
      </StyledListLink>
    </ListItemWrapper>
  ),
);

StakeholderListItem.displayName = "StakeholderListItem";
